import React, { useState } from 'react'
import { IconButton } from '@paintscout/ui'
import CloseIcon from '@material-ui/icons/Close'
import AddAdditionalWorkSelectView from './AddAdditionalWorkPanel/AddAdditionalWorkSelectView'
import type { AddAdditionalWorkPanelProps } from './AddAdditionalWorkPanel/types'
import { useAddAdditionalWorkPanelStyles } from './AddAdditionalWorkPanel/useAddAdditionalWorkPanelStyles'

export default function AddAdditionalWorkPanel(props: AddAdditionalWorkPanelProps) {
  const { options = [] } = props
  const classes = useAddAdditionalWorkPanelStyles()
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())

  function toggleOption(id: string) {
    setSelectedIds((prev) => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <span className={classes.headerTitle}>Add Additional Work</span>
        <IconButton className={classes.closeButton} onClick={props.onClose} size="small" aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <div className={classes.body}>
        <AddAdditionalWorkSelectView
          options={options}
          selectedIds={selectedIds}
          onToggleOption={toggleOption}
          onAddSelected={() => props.onAddSelected?.(Array.from(selectedIds))}
          onAddLineItem={() => props.onAddLineItem?.()}
          classes={classes}
        />
      </div>
    </div>
  )
}

export type {
  AddAdditionalWorkPanelProps,
  AdditionalWorkItemType,
  AdditionalWorkOption,
  AdditionalWorkOptionSubarea,
  AdditionalWorkRateCategory,
  WorkArea
} from './AddAdditionalWorkPanel/types'
